const ReviewForm = (props) => {
    const {data, fullSize} = props
    let elements = []

    for (const key in data) {
        if (Object.hasOwnProperty.call(data, key)) {
            const value = data[key];
            const componentId = key.toLowerCase().replace(/ +/g,'')
            elements.push(
            <div key={"data-review-"+componentId} className="row bottomMarginNormal reviewFormItem">
                <div className={fullSize ? "col-lg-4" : "col-lg-3"}>
                    <b>{key}</b>
                </div>
                <div className={fullSize ? "col-lg-8" : "col-lg-5"}>
                    {value}
                </div>
            </div>
            )
        }
    }

    return (
        <>
           {elements}
        </>
    )
}

export default ReviewForm
